import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from '@/core/api/base-service';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { AreaAtuacaoPorEspecialidadeResponse, EspecialidadeListaResponse, EspecialidadeRequest, EspecialidadeResponse } from '@/core/api/sicom-api/registro/medico/especialidade/especialidade.model';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { environment } from '../../../../../../../environments/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class EspecialidadeService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }
    readonly PATH = SICOM_PATHS.registro.medico.especialidades;
    readonly PATH_ESPECIALIDADE = SICOM_PATHS.registro.medico.especialidade;
    readonly PATH_LISTAR = SICOM_PATHS.registro.medico.especialidadesListar;
    readonly PATH_AREAS_ATUACAO = SICOM_PATHS.registro.medico.especialidadesAreasAtuacao;

    private pessoaParams(p: Pessoa): HttpParams {
        return new HttpParams().set('id', String(p.id)).set('uf', String(p.uf));
    }

    buscar(params: Pessoa, context?: HttpContext): Observable<EspecialidadeRequest[]> {
        return this.http.get<EspecialidadeRequest[]>(this.PATH, { params: this.pessoaParams(params), context });
    }

    listar(context?: HttpContext): Observable<EspecialidadeListaResponse[]> {
        return this.http.get<EspecialidadeListaResponse[]>(this.PATH_LISTAR, { context });
    }

    listarAreasAtuacaoPorEspecialidade(idEspecialidade: number, context?: HttpContext): Observable<AreaAtuacaoPorEspecialidadeResponse[]> {
        const query: any = { idEspecialidade };
        return this.http.get<AreaAtuacaoPorEspecialidadeResponse[]>(this.PATH_AREAS_ATUACAO, { params: query, context });
    }

    criar(especialidade: Partial<EspecialidadeRequest>): Observable<EspecialidadeResponse> {
        return this.http.post<EspecialidadeResponse>(this.PATH_ESPECIALIDADE, especialidade);
    }

    atualizar(especialidade: EspecialidadeRequest): Observable<EspecialidadeResponse> {
        return this.http.put<EspecialidadeResponse>(this.PATH_ESPECIALIDADE, especialidade);
    }

    remover(especialidade: EspecialidadeRequest): Observable<boolean> {
        let params = new HttpParams().append('especialidIdEspecialidade', especialidade.especialidIdEspecialidade).append('medicoUfSgUf', especialidade.medicoUfSgUf).append('medicoIdSolicitante', especialidade.medicoIdSolicitante);

        return this.http.delete<boolean>(this.PATH_ESPECIALIDADE, { params });
    }
}
